import {FC, useState} from "react";
import {useSite} from "../../../../store/siteContext.ts";
import {Column, FlexSpace} from "../../../../atoms/Layout.tsx";
import AppBarWithNavigation from "../../../../organisms/AppBarWithNavigation.tsx";
import {Text} from "../../../../style/typography.tsx";
import Panel from "../../../../atoms/Panel.tsx";
import Button from "../../../../atoms/Button.tsx";
import {CopySuccessIcon} from "../../../../atoms/Icon";
import TextOutput from "../../../../atoms/TextOutput.tsx";
import {dashboardHome} from "../../../../helpers/paths.ts";

const LinkPage: FC = () => {
    const site = useSite();
    const [copied, setCopied] = useState(false);

    const url = `${window.location.origin}/feedback/${site.id}/${site.idCode}`

    const copyUrl = () => {
        void navigator.clipboard.writeText(url);
        setCopied(true);
        setTimeout(() => setCopied(false), 10000);
    }

    return <Column grow>
        <AppBarWithNavigation backTo={dashboardHome(site)} />
        <Column grow padding="20">
            <FlexSpace />
            <Text role="heading" size="1" weight="medium">
                Share the link below with your team
            </Text>
            <FlexSpace />
            <Panel>
                <Column gap="20">
                    <Text role="description" size="2" weight="medium">
                        Copy and paste this link to send to your team
                    </Text>
                    <TextOutput>
                        {url}
                    </TextOutput>
                    <Button size="large" onClick={copyUrl}>
                        {copied ? "Copied" : "Copy"} <CopySuccessIcon size={20} />
                    </Button>
                </Column>
            </Panel>
        </Column>
    </Column>
}

export default LinkPage